<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <div class="md-layout">
          <div class="md-layout-item p-0">

            <router-link
              :to="{ name: 'ReleaseUpdates' }"
              class="release-update-banner"
            >
              <md-icon>campaign</md-icon>
              <span class="release-update-banner-text">
                <b>What's new — Bizminer Data Update: August 2026</b>
              </span>
              <span class="release-update-banner-cta">
                See what's new
                <i class="md-icon materials-icon-round">arrow_forward</i>
              </span>
            </router-link>

            <md-card class="welcome-card-wrap my-2 pb-0">
              <md-card-header class="md-card-header-icon page_header">
                <div class="card-icon">
                  <md-icon>perm_identity</md-icon>
                </div>
                <h4 class="title text-center" v-if="loaded">
                  <div v-if="firstVisit">
                    Welcome to the new Bizminer {{ username }}!
                    <br />
                    <small>
                      Select New Profile or New Report to begin your search
                      process.
                    </small>
                  </div>
                  <div v-if="!firstVisit">
                    Welcome back {{ username }}!
                    <br />
                    <small>
                      Select New Profile or New Report to begin your search
                      process. Or, take a product tour and watch informative
                      videos below.
                    </small>
                  </div>
                </h4>
              </md-card-header>

              <md-card-content class="welcome-card-container row_Wpr">
                <div id="typography">
                  <div class="row pt-4">

                    <!-- <h1 class="section_header">Conduct Research?</h1> -->
                    <div class="md-layout research">
                      <div class="md-layout-item md-medium-size-100 md-size-100">
                        <div class="md-layout">
                          <div
                            class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25 research_profile p-0"
                          >
                            <profile-card header-color="blue">
                              <template slot="header">
                                <div class="headerWpr">
                                  <!-- <div class="card-icon">
                                    <md-icon>business_center</md-icon>
                                  </div>-->

                                  <img src="/img/briefcase.png" alt="Briefcase image from Financial Profile" />
                                  <span
                                    class="category new-profile-card-title"
                                  >Industry Financial Profile</span>
                                </div>
                              </template>
                              <template slot="content">
                                <div
                                  :class="isFinancialProfile ? 'info-wrap' : 'info-wrap non-subscriber no-click'"
                                >
                                  <p>
                                    <a
                                      href="/sample/industry-financial-profile"
                                      target="_blank"
                                      style="float: right;"
                                    >
                                      <span style="float: right; font-size: 12px; margin-top: 2px; text-transform: initial;">Sample Profile</span>
                                      <i
                                        class="md-icon materials-icon-round"
                                        style="float: right; color: #002277;"
                                      >open_in_new</i>

                                        <md-tooltip md-direction="top">Sample Profile</md-tooltip>
                                        
                                      </a>
                                    <!--<h5>Research an Industry's Financial Performance</h5>-->
                                    <b>Includes:</b>
                                  </p>
                                  <ul>
                                    <li>
                                      <i class="md-icon dark-blue-color">check</i>US and
                                      Local
                                      <md-tooltip
                                        md-direction="top"
                                      >Analysis for 5000-plus industries; 15 sales brackets; 350 US-state and metro market options; 36 ratios with detailed P&L</md-tooltip>
                                    </li>
                                    <!-- SP hidden until 3_26 MF/SPIF data exists — see helpers/spifAvailability.js -->
                                    <li v-if="spSelectorEnabled">
                                      <i class="md-icon dark-blue-color">check</i>Sole
                                      Proprietorship
                                      <md-tooltip
                                        md-direction="top"
                                      >Analysis for 3000-plus industries; 21 line profit & loss 1040C format and line items; 12 financial ratios;</md-tooltip>
                                    </li>
                                    <li>
                                      <i class="md-icon dark-blue-color">check</i>Valuation
                                      Multiples
                                      <md-tooltip
                                        md-direction="top"
                                      >Price:Earnings and Price:Revenue multiples derived from 34,000 transactions in the DealStats database. Quartile 1-Median and Quartile-3 values for each industry (all 4 sales groups).</md-tooltip>
                                    </li>
                                  </ul>
                                  <span
                                   class="font-size-span-search"
                                  >(Industry Financial Research: Our Data)</span>
                                </div>
                                <router-link
                                  :to="{
                                    name: 'NewProfile',
                                    params: { id: 'industry-financial-profile' },
                                  }"
                                  :class="isFinancialProfile ? '' : 'non-subscriber no-click'"
                                >
                                  <md-button class="md-info md-block dark-blue-color" @click="startResearching">
                                    <!-- <i class="md-icon materials-icon-round">search</i> -->
                                    Start Researching
                                  </md-button>
                                </router-link>
                              </template>
                            </profile-card>
                          </div>
                          <div
                            class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25 research_profile p-0"
                          >
                            <profile-card>
                              <template slot="header">
                                <div class="headerWpr">
                                  <!-- <div class="card-icon">
                                    <md-icon>business_center</md-icon>
                                  </div>-->
                                  <img src="/img/market.png" alt="market image from Market Profile" />
                                  <span
                                    class="category new-profile-card-title"
                                  >Industry Market Profile</span>
                                </div>
                              </template>
                              <template slot="content">
                                <div
                                  :class="isMarketProfile ? 'info-wrap' : 'info-wrap non-subscriber no-click'"
                                >
                                  <p>
                                    <a
                                      href="/sample/industry-market-profile"
                                      target="_blank"
                                      style="float: right;"
                                    >
                                      <span style="float: right; font-size: 12px; margin-top: 2px; text-transform: initial;">Sample Profile</span>
                                      <i
                                        class="md-icon materials-icon-round"
                                        style="float: right; color: #002277;"
                                      >open_in_new</i>
                                      <md-tooltip md-direction="top">Sample Profile</md-tooltip>
                                    </a>
                                    <!--<h5>Research an Industry in Specific Market</h5>-->
                                    <b>Includes:</b>
                                  </p>
                                  <ul>
                                    <li>
                                      <i class="md-icon dark-blue-color">check</i>Competitive Market Narratives
                                      <md-tooltip
                                        md-direction="top"
                                      >Custom narrative competitive analysis your industry and your market area, concise narrative analysis.</md-tooltip>
                                    </li>
                                    <li>
                                      <i class="md-icon dark-blue-color">check</i>Demographics
                                      <md-tooltip
                                        md-direction="top"
                                      >Add radii for population demographics in any US market. Value and percentages for population, age, race-ethnicity, employment, income education and housing</md-tooltip>
                                    </li>
                                  </ul>
                                  <span class="font-size-span-search">(Industry Market Research: Our Data)</span>
                                </div>
                                <router-link
                                  :to="{
                                    name: 'NewMarketProfile',
                                  }"
                                  :class="isMarketProfile ? '' : 'non-subscriber no-click'"
                                >
                                  <md-button class="md-info md-block dark-blue-color" @click="startResearching">
                                    <!-- <i class="md-icon materials-icon-round">search</i> -->
                                    Start Researching
                                  </md-button>
                                </router-link>
                              </template>
                            </profile-card>
                          </div>
                          <div
                            class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25 research_profile p-0"
                          >
                            <profile-card header-color="blue">
                              <template slot="header">
                                <div class="headerWpr">
                                  <!-- <div class="card-icon">
                                    <md-icon>insights</md-icon>
                                  </div>-->
                                  <img src="/img/company.png" alt="company image from Company Profile" />
                                  <span class="category new-profile-card-title">Company Profile</span>
                                </div>
                              </template>
                              <template slot="content">
                                <div
                                  :class="isCompanyProfile ? 'info-wrap' : 'info-wrap non-subscriber no-click'"
                                >
                                  <p>
                                    <a
                                      href="/sample/company-profile"
                                      target="_blank"
                                      style="float: right;"
                                    >
                                      <span style="float: right; font-size: 12px; margin-top: 2px; text-transform: initial;">Sample Profile</span>
                                      <i
                                        class="md-icon materials-icon-round"
                                        style="float: right; color: #002277;"
                                      >open_in_new</i>
                                      <md-tooltip md-direction="top">Sample Profile</md-tooltip>
                                    </a>
                                    <!--<h5>Research a Company</h5>-->
                                    <b>Includes:</b>
                                  </p>
                                  <ul>
                                    <li>
                                      <i class="md-icon dark-blue-color">check</i>Company Insights
                                      <md-tooltip
                                        md-direction="top"
                                      >Fast Search-by-Name access to more than 9 million businesses, core benchmarks and projected profit-expense levels, expense and earnings scenarios, content refreshed every month!</md-tooltip>
                                    </li>
                                  </ul>
                                  <span class="font-size-span-search">(Company Research: Our Data)</span>
                                </div>
                                <router-link
                                  :to="{
                                    name: 'CompanySearch',
                                  }"
                                  :class="isCompanyProfile ? '' : 'non-subscriber no-click'"
                                >
                                  <md-button class="md-info md-block dark-blue-color" @click="startResearching">
                                    <!-- <i class="md-icon materials-icon-round">search</i> -->
                                    Start Researching
                                  </md-button>
                                </router-link>
                              </template>
                            </profile-card>
                          </div>
                          <div v-if="!isAcademic" class="md-layout-item md-medium-size-25 md-size-25 analyze" style="padding-left: 5px!important;">
                            <profile-card header-color="blue">
                              <template slot="header">
                                <div class="headerWpr">
                                  <img src="/img/prospect_list.png" alt="Prospect List image from Prospect List" />
                                  <span class="category new-profile-card-title">
                                    Build A
                                    <br />Prospect List
                                  </span>
                                </div>
                              </template>
                              <template slot="content">
                                <div class="info-wrap">
                                  <p>Includes:</p>
                                  <ul>
                                    <li>
                                      <i class="md-icon dark-blue-color">check</i>Expanded Filter Option
                                      <md-tooltip
                                        md-direction="top"
                                      >Filter by industry, contacts, market area, estimated revenue, estimated value, years in business, employee count, franchise status, web presense, and social presense.</md-tooltip>
                                    </li>
                                  </ul>
                                </div>
                                <router-link :to="{ name: 'ProspectSearch' }">
                                  <md-button
                                    class="md-info md-block"
                                    @click="startResearching"
                                  >Start Prospecting</md-button>
                                </router-link>
                              </template>
                            </profile-card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4 pt-4">
                    <div class="md-layout research reports">
                      <div class="md-layout-item md-medium-size-100 md-size-100">
                        <div class="md-layout">
                          <div
                          v-if="!isAcademic"
                            class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25 research_profile p-0"
                          >
                            <profile-card header-color="blue">
                              <template slot="header">
                                <div class="headerWpr small">
                                  <img src="/img/financial_report.png" alt="Financial Report Image from Financial Report" />
                                  <span class="category new-profile-card-title">Financial Report</span>
                                </div>
                              </template>
                              <template slot="content">
                                <div
                                  :class="isFinancialReport? 'info-wrap' : 'info-wrap non-subscriber no-click'"
                                >
                                  <a
                                    href="/sample/financial-report"
                                    target="_blank"
                                    style="float: right;"
                                  >
                                  <span style="float: right; font-size: 12px; margin-top: 2px;">Sample Report</span>
                                    <i
                                      class="md-icon materials-icon-round"
                                      style="float: right; color: #002277;"
                                    >open_in_new</i>
                                    <md-tooltip md-direction="top">Sample Report</md-tooltip>
                                  </a>
                                  <h5>Benchmark Financials</h5>
                                  <p>
                                    <b>Includes:</b>
                                  </p>
                                  <ul>
                                    <li>
                                      <i class="md-icon dark-blue-color">check</i>US and
                                      Local
                                      <md-tooltip
                                        md-direction="top"
                                      >Analysis for 5000-plus industries; 15 sales brackets; 350 US-state and metro market options; 36 ratios with detailed P&L, five-star ratio scoring</md-tooltip>
                                    </li>
                                    <!-- SP hidden until 3_26 MF/SPIF data exists — see helpers/spifAvailability.js -->
                                    <li v-if="spSelectorEnabled">
                                      <i class="md-icon dark-blue-color">check</i>Sole
                                      Proprietorship
                                      <md-tooltip
                                        md-direction="top"
                                      >Analysis for 3000-plus industries; 21 line profit & loss 1040C format and line items; 12 dynamically scored financial ratios;</md-tooltip>
                                    </li>
                                    <li>
                                      <i class="md-icon dark-blue-color">check</i>Valuation
                                      Multiples
                                      <md-tooltip
                                        md-direction="top"
                                      >Price:Earnings and Price:Revenue multiples derived from 34,000 transactions in the DealStats database. Quartile 1-Median and Quartile-3 values for each industry (all 4 sales groups).</md-tooltip>
                                    </li>
                                  </ul>
                                  <span
                                   class="font-size-span-search"
                                  >(Financial Analysis: Your Data benchmarked against Our Data)</span>
                                </div>
                                <router-link
                                  to="/create-report-format/financial"
                                  :class="isFinancialReport? '' : 'non-subscriber no-click'"
                                >
                                  <md-button
                                    class="md-info secondary md-block"
                                    @click="startResearching"
                                  >Start Analysis</md-button>
                                </router-link>
                              </template>
                            </profile-card>
                          </div>
                          <div
                           v-if="!isAcademic"
                            class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25 research_profile p-0"
                          >
                            <profile-card>
                              <template slot="header">
                                <div class="headerWpr small">
                                  <img src="/img/market_report.png" alt="Market Report Image from Market Report" />
                                  <span class="category new-profile-card-title">Market Report</span>
                                </div>
                              </template>
                              <template slot="content">
                                <div
                                  :class="isMarketReport? 'info-wrap' : 'info-wrap non-subscriber no-click'"
                                >
                                  <a
                                    href="/sample/market-report"
                                    target="_blank"
                                    style="float: right;"
                                  >
                                    <span style="float: right; font-size: 12px; margin-top: 2px;">Sample Report</span>
                                    <i
                                      class="md-icon materials-icon-round"
                                      style="float: right; color: #002277;"
                                    >open_in_new</i>
                                    <md-tooltip md-direction="top">Sample Report</md-tooltip>
                                  </a>
                                  <h5>Benchmark Market Data</h5>
                                  <p>
                                    <b>Includes:</b>
                                  </p>
                                  <ul>
                                    <li>
                                      <i class="md-icon dark-blue-color">check</i>Competitive Market Narratives
                                      <md-tooltip
                                        md-direction="top"
                                      >Custom narrative competitive analysis of your firm, your industry and your market area, concise narrative analysis.</md-tooltip>
                                    </li>
                                  </ul>
                                  <span
                                    class="font-size-span-search"
                                  >(Market Analysis: Your Data benchmarked against Our Data)</span>
                                </div>
                                <router-link
                                  to="/create-report-format/market"
                                  :class="isMarketReport? '' : 'non-subscriber no-click'"
                                >
                                  <md-button
                                    class="md-info secondary md-block"
                                    @click="startResearching"
                                  >Start Analysis</md-button>
                                </router-link>
                              </template>
                            </profile-card>
                          </div>
                          <div
                          v-if="!isAcademic"
                            class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25 research_profile p-0"
                          >
                            <profile-card header-color="blue">
                              <template slot="header">
                                <div class="headerWpr small">
                                  <img src="/img/valuation_report.png" alt="Valuation Report image from Valuation Report" />
                                  <span class="category new-profile-card-title">Valuation Report</span>
                                </div>
                              </template>
                              <template slot="content">
                                <div
                                  :class="isValuationReport? 'info-wrap' : 'info-wrap non-subscriber no-click'"
                                >
                                  <a
                                    href="/sample/valuation-report"
                                    target="_blank"
                                    style="float: right;"
                                  >
                                    <span style="float: right; font-size: 12px; margin-top: 2px;">Sample Report</span>
                                    <i
                                      class="md-icon materials-icon-round"
                                      style="float: right; color: #002277;"
                                    >open_in_new</i>
                                    <md-tooltip md-direction="top">Sample Report</md-tooltip>
                                  </a>
                                  <h5>Analyze Business Valuation Data</h5>
                                  <p>
                                    <b>Includes:</b>
                                  </p>
                                  <ul>
                                    <li>
                                      <i class="md-icon dark-blue-color">check</i>Vestimate Pro
                                      <md-tooltip
                                        md-direction="top"
                                      >Anchored by our database of over 32,000 business transactions, integrates Bizminer's acclaimed industry financial metrics, incorporates financial and market analytics, detailed tables—with easy-to-absorb starred KPI ratio scoring.</md-tooltip>
                                    </li>
                                  </ul>
                                  <span
                                    class="font-size-span-search"
                                  >(Valuation Analysis: Your Data benchmarked against Our Data)</span>
                                </div>
                                <router-link
                                  to="/create-report-format/valuation"
                                  :class="isValuationReport? '' : 'non-subscriber no-click'"
                                >
                                  <md-button
                                    class="md-info secondary md-block"
                                    @click="startResearching"
                                  >Start Analysis</md-button>
                                </router-link>
                              </template>
                            </profile-card>
                          </div>
                          <div
                          v-if="!isAcademic"
                            class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25 research_profile p-0"
                          >
                            <profile-card header-color="blue">
                              <template slot="header">
                                <div class="headerWpr small">
                                  <img src="/img/company_report.png" alt="Company Report image from Company Report" />
                                  <span class="category new-profile-card-title">Company Report</span>
                                </div>
                              </template>
                              <template slot="content">
                                <div
                                  :class="isCompanyReport? 'info-wrap' : 'info-wrap non-subscriber no-click'"
                                >
                                  <a
                                    href="/sample/company-report"
                                    target="_blank"
                                    style="float: right;"
                                  >
                                    <span style="float: right; font-size: 12px; margin-top: 2px;">Sample Report</span>
                                    <i
                                      class="md-icon materials-icon-round"
                                      style="float: right; color: #002277;"
                                    >open_in_new</i>
                                    <md-tooltip md-direction="top">Sample Report</md-tooltip>
                                  </a>
                                  <h5>Benchmark Company Performance</h5>
                                  <p>
                                    <b>Includes:</b>
                                  </p>
                                  <ul>
                                    <li>
                                      <i class="md-icon dark-blue-color">check</i>SWOT-Express
                                      <md-tooltip
                                        md-direction="top"
                                      >Financial, industry market and valuation analysis in one report, analyze your own firm, create and deliver monthly SWOT updates to your clients, how any firm stacks up to industry financial KPIs, firm-specific market values</md-tooltip>
                                    </li>
                                  </ul>
                                  <span
                                    class="font-size-span-search"
                                  >(Company Analysis: Your Data benchmarked against Our Data)</span>
                                </div>
                                <router-link
                                  to="/create-report-format/company"
                                  :class="isCompanyReport? '' : 'non-subscriber no-click'"
                                >
                                  <md-button
                                    class="md-info secondary md-block"
                                    @click="startResearching"
                                  >Start Analysis</md-button>
                                </router-link>
                              </template>
                            </profile-card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ProfileCard } from '@/components';
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import { posthog } from '@/main';
import { SP_SELECTOR_ENABLED } from '@/helpers/spifAvailability';

export default {
  name: 'search',
  components: {
    ProfileCard,
  },
  data() {
    return {
      spSelectorEnabled: SP_SELECTOR_ENABLED,
      firstVisit: undefined,
      loaded: false,
      selected: [],
      username: '',
      tableData: [],
      key: 0,
      isFinancialProfile: false,
      isFinancialReport: false,
      isMarketProfile: false,
      isMarketReport: false,
      isCompanyReport: false,
      isCompanyProfile: false,
      isValuationReport: false,
    };
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
      subscriptions: (state) => state.user.user_subscriptions ?? null,
      isRetail: (state) => (state.user.user_type.retail/* || state.user.allow_retail*/) ?true: null,
      isAcademic: (state) => state.user.user_type.academic,
      isSubscriber: (state) => state.user.user_type.subscriber ?? null,
      isIBBA2021:  (state) => state.user.user_IBBA2021 ?? null,
      userAccess:  (state) => state?.user?.userAccess ?? null,
    }),
  },
  updated() {
     if ((this.subscriptions && this.subscriptions.length>0) || this.isRetail || this.isAcademic){
       this.checkSubscriptions()
     }


  },
  methods: {
    ...mapActions({
      savePullTime: 'tracking/savePullTime',
    }),
    checkSubscriptions: function () {

      if (this.isRetail || this.isAcademic) {
        this.isFinancialProfile = true;
        this.isFinancialReport = true;
        this.isMarketProfile = true;
        this.isMarketReport = true;
        this.isCompanyReport = true;
        this.isCompanyProfile = true;
        this.isValuationReport = true;
      } else {
        if ((this.userAccess && this.userAccess.ifpAccess.access) || this.subscriptions.includes('usif') || this.subscriptions.includes('lif')|| this.subscriptions.includes('usif_p')|| this.subscriptions.includes('lif_p'))
          this.isFinancialProfile = true;

        if ((this.userAccess && this.userAccess.ifrAccess.access) || this.subscriptions.includes('usif') || this.subscriptions.includes('lif')|| this.subscriptions.includes('usif_r')|| this.subscriptions.includes('lif_r'))
          this.isFinancialReport = true;

        if ((this.userAccess && this.userAccess.impAccess.access) || this.subscriptions.includes('usmr') || this.subscriptions.includes('lmr')|| this.subscriptions.includes('usmr_p')|| this.subscriptions.includes('lmr_p'))
          this.isMarketProfile = true;

        if ((this.userAccess && this.userAccess.imrAccess.access) || this.subscriptions.includes('usmr') || this.subscriptions.includes('lmr')|| this.subscriptions.includes('usmr_r')|| this.subscriptions.includes('lmr_r'))
          this.isMarketReport = true;

        if ((this.userAccess && this.userAccess.crAccess.access) ||this.subscriptions.includes('swot'))
          this.isCompanyReport = true;

        if (this.subscriptions.includes('css'))
          this.isCompanyProfile = true;

        if ((this.userAccess && this.userAccess.vrAccess.access) ||this.subscriptions.includes('vpro'))
          this.isValuationReport = true;
      }
    },
    setProfileInfo: function (
      productType,
      industry,
      marketArea,
      salesClass,
      mapCenterPoint,
      zips,
      isReport
    ) {

      if (productType === 'if' || productType === 'list') {
        if (industry)
          this.$store.commit('SET_INDUSTRY', industry);
        if (marketArea)
          this.$store.commit('SET_MARKET_AREA', marketArea);
        if (salesClass)
          this.$store.commit('SET_SALES_CLASS', salesClass);

        if (productType === 'list')
          this.$router.push({ name: 'ProspectSearch' });
        else if (isReport)
          this.$router.push({ name: 'CreateReportFormat' });
        else
          this.$router.push({ name: 'NewProfile' });

      } else if (productType === 'lmr') {
        if (industry)
          this.$store.commit('M_SET_INDUSTRY', industry);

        if (marketArea)
          this.$store.commit('M_SET_MARKET_AREA', marketArea);


        if (isReport)
          this.$router.push({ name: 'CreateReportFormat' });
        else
          this.$router.push({ name: 'NewMarketProfile' });
      }
    },
    startResearching: function () {
      posthog.capture('industry_search_run');
      this.savePullTime({ userId: this.auth_user?.user?.userID })
      this.$store.commit('SET_INDUSTRY', null);
      this.$store.commit('SET_MARKET_AREA', null);
      this.$store.commit('SET_SALES_CLASS', null);

      this.$store.commit('M_SET_INDUSTRY', null);
      this.$store.commit('M_SET_MARKET_AREA', null);
    },
    setTypeName: function (type, isReport) {


      if (!isReport) {
        switch (type) {
          case 'if':
            return 'Industry Financial Profile';
          case 'lmr':
            return 'Industry Market Profile';
          case 'list':
            return 'Prospect List';
          default:

            return type;
        }
      }
      else {
        switch (type) {
          case 'if':
            return 'Industry Financial Report';
          case 'lmr':
            return 'Industry Market Report';
          case 'list':
            return 'Prospect List';
          default:

            return type;
        }
      }

    },
    setUsername: function () {
      this.username = localStorage.getItem('userFirstName');
    },
    getData: function (name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }
    },
    getName: function (name) {
      if (name) {
        return name.split('[')[0].trim();
      } else {
        return '-';
      }
    },
    getRecentSearches: async function () {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/favorites/recentSearches',
          {},
          {
            params: {
              session_id: currentSession,
              limit: 70,
              shown: true,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/recentSearches" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const { data } = res.data;


          data.length == 0
            ? (this.firstVisit = true)
            : (this.firstVisit = false);

          var recentAux = {};
          data.forEach((recentSearch) => {

            delete recentSearch.id;
            if (this.checkConditionsToAdd(recentSearch, recentAux)) {
              this.tableData.push({
                productType: recentSearch.type,
                isReport: recentSearch.isReport,
                industry: recentSearch.naics != 0 ? `${recentSearch.industry} [${recentSearch.naics}]` : '-',

                marketArea: recentSearch.area_id != 0 ? `${recentSearch.area} [${recentSearch.area_id}]` : null,
                area_id: recentSearch.area_id,
                salesClass:
                  recentSearch.sales_class_id !== '' &&
                    recentSearch.sales_class_id !== '0'
                    ? `${recentSearch.sales_class} [${recentSearch.sales_class_id}]`
                    : recentSearch.sales_class,
                mapCenterPoint:
                  recentSearch.radius !== '0.0'
                    ? `${recentSearch.radius} miles away from ${recentSearch.map_center}, ${recentSearch.map_center_zip} [map_center]`
                    : '',
                zips:
                  recentSearch.zips !== '0' ? `${recentSearch.zips} [zips]` : '',
              });
              recentAux = recentSearch;
            }
          });
          this.tableData = this.tableData.slice(0, 10)
          this.loaded = true;
        });
    },
    checkConditionsToAdd: function (recentSearch, recentAux) {
      if (recentSearch.type !== 'mf' &&
        this.checkSameResult(recentSearch, recentAux) &&
        this.checkIfSomethingSelected(recentSearch)
      )
        return true;

      return false
    },
    checkSameResult: function (recentSearch, recentAux) {
      if (
        recentSearch.area !== recentAux.area ||
        recentSearch.industry !== recentAux.industry ||
        recentSearch.isReport !== recentAux.isReport ||
        recentSearch.naics !== recentAux.naics ||
        recentSearch.sales_class !== recentAux.sales_class ||
        recentSearch.type !== recentAux.type)
        return true;

      return false;
    },
    checkIfSomethingSelected: function (recentSearch) {
      if (recentSearch.area_id != 0 ||
        recentSearch.naics != 0 ||
        recentSearch.sales_class_id != 0)
        return true

      return false;
    },
     async getAuth() {
      try {
        this.$store.dispatch('authenticateUser').then((res) => {
          if (res && res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
        });
      } catch (e) {
        this.$store.dispatch('alerts/error', "We can't get data for this user");
      }
    },
  },

  async created() {
    if(this.isAcademic)
      this.checkSubscriptions()

     await this.getAuth();
    this.setUsername();
    await this.getRecentSearches();
  },
  watch:{
    subscriptions(){
     if ((this.subscriptions && this.subscriptions.length>0) || this.isRetail || this.isAcademic)
        this.checkSubscriptions()
    },
    isAcademic(){
       if ((this.subscriptions && this.subscriptions.length>0) || this.isRetail || this.isAcademic)
        this.checkSubscriptions()
    }
  }
};
</script>
<style>
.clickable {
  cursor: pointer;
}
.font-size-span-search{
  font-size: 11px;
}

.release-update-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 12px 0 0;
  padding: 12px 18px;
  border: 1px solid #cdd8f0;
  border-left: 4px solid #002277;
  border-radius: 6px;
  background: #f2f6ff;
  color: #002277;
  text-decoration: none;
  transition: background 0.15s ease;
}
.release-update-banner:hover {
  background: #e6eeff;
  color: #002277;
}
.release-update-banner > .md-icon {
  color: #002277;
  flex: 0 0 auto;
}
.release-update-banner-text {
  flex: 1 1 auto;
  font-size: 13px;
  line-height: 1.35;
}
.release-update-banner-cta {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}
.release-update-banner-cta .md-icon {
  color: #002277;
  font-size: 18px !important;
  margin-left: 4px;
}
@media only screen and (max-width: 600px) {
  .release-update-banner-cta {
    display: none;
  }
}


.md-button.md-info.dark-blue-color, .md-button.md-info i, .md-button.md-info:hover, .md-button.md-info:hover i, .md-button.md-info:focus, .md-button.md-info:focus i, .md-button.md-info:active, .md-button.md-info:active i, .md-button.md-info.active, .md-button.md-info.active i, .md-button.md-info:active:focus, .md-button.md-info:active:focus i, .md-button.md-info:active:hover, .md-button.md-info:active:hover i, .md-button.md-info.active:focus, .md-button.md-info.active:focus i, .md-button.md-info.active:hover, .md-button.md-info.active:hover i, .open > .md-button.md-info.dropdown-toggle, .open > .md-button.md-info.dropdown-toggle i, .open > .md-button.md-info.dropdown-toggle:focus, .open > .md-button.md-info.dropdown-toggle:focus i, .open > .md-button.md-info.dropdown-toggle:hover, .open > .md-button.md-info.dropdown-toggle:hover i {
  color: #002277!important;
}

</style>
